<template>
  <div class="examPack">

    <div class="list">

      <div class="item" v-for="(item, index) in roomList" :key="index" @click="tabId = item.id">
        <img class="item-image" src="https://staticfile.xlcwx.com/m-images/yth/lzjxy/img/study/q1.png" />
        <div class="item-content flex-c" :class="item.seeNum && !IsPurchase ? 'shiting-title' : ''">
          <div class="item-title ellipsis">
            {{ item.paperName }}
          </div>
          <div class="item-size ellipsis">

            <div v-for="(items, indexs) in item.labelNameList" :key="indexs">{{ items }}</div>
          </div>
        </div>

        <!-- <div v-if="item.paperPrice > 0 && item.status == 2" class="keep-learn" @click.stop="goOrder(item, 12)">
          立即购买
        </div> -->
        <div v-if="item.status == 1 || !item.paperPrice || item.paperPrice == 0" class="keep-learn "
          @click="checkClick(item)">
          开始答题
        </div>
      </div>
      <div class="nothing" v-if="!roomList || roomList.length == 0">
        <!-- <img class="nothing-img" src="https://staticfile.xlcwx.com/m-images/yth/lzjxy/img/study/noLearn.png" /> -->
        <div class="nothing-text">暂无内容哦~</div>
      </div>
    </div>

  </div>
</template>
<script> 
import Vue from 'vue'
 
import { getInfo, getToken } from '@/api/cookies'
import { HomeClient } from "@/api/home";
const homeClient = new HomeClient();
export default {
  data() {
    return {
      userInfo: null, roomList: [], dialogVisible: false, bqList: [],
      activeName: null
    }
  },
  props: {
    IsPurchase: {
      type: Boolean,
      default: false,
    },
    id: {
      type: String,
    },
    productLine: {
      type: Number,
    },

  },
  created() {
    this.userInfo = getInfo()

    this.getContactPcPageList()

  },
  methods: {
    handleClick(tab, event) {
      console.log(tab, event);
      this.getContactPcPageList()
    },
 
  async  getContactPcPageList() {
       const params = new URLSearchParams({
        kcId: this.id,
        oneLabelId:2
      });
      const res = await homeClient.getContactPcPageList(params);
     this.roomList = res.data
    
    },
    /* 下载 */ 
    checkClick(item) {
      let userInfo = getInfo()
      if (!userInfo) {
        Vue.prototype.goLoginView(false)
        return
      }
      if (!this.IsPurchase) {
        this.$notify({
          title: "提示",
          message: "您还没有购买!",
          type: "warning",
        });
        return;
      }
        Vue.prototype.goExam(      {contactId:item.contactId,examType:15}      );
        
    },
  },
}
</script>
<style lang="less" scoped>
.examPack {
  .list {
    width: 100%;
    padding: 0px 32px;
    background: #ffffff;

    .item {
      position: relative;
      padding: 32px 0px;
      border-bottom: 1px solid #eee;
      display: flex;
      align-items: center;

      .item-image {
        width: 60px;
        // height: 80px;
        flex-shrink: 0;
        background: #f7f8f9;
        margin-right: 12px;
      }

      .item-content {
        width: calc(100% - 170px);
        height: 60px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: flex-start;

        &.shiting-title::after {
          // content: "可试看";
          width: 48px;
          height: 20px;
          color: #ff5e51;
          background-color: #ffedeb;
          border-radius: 2px;
          font-size: 12px;
          line-height: 20px;
          text-align: center;
          margin-left: 20px;
        }

        .item-title {
          font-size: 16px;
          font-family: Microsoft YaHei-Regular;
          font-weight: 400;
          color: #333333;
          line-height: 24px;
          max-width: calc(100% - 80px);
        }

        .item-size {
          max-width: 500px;
          display: flex;
          margin-top: 10px;
          overflow-x: hidden;

          >div {
            padding: 1px 4px;
            background: #FFEEED;
            border-radius: 4px 4px 4px 4px;

            font-family: PingFang SC, PingFang SC;
            font-weight: 400;
            font-size: 12px;
            color: #FF5E51;
            margin-right: 5px;
          }
        }
      }

      .keep-learn {
        flex-shrink: 0;
      }
    }
  }

  /* 试kan */
  .audition {
    width: 48px;
    height: 20px;
    background: #ffedeb;
    border-radius: 2px 2px 2px 2px;
    font-size: 12px;
    font-family: Microsoft YaHei-Regular;
    font-weight: 400;
    color: #ff5e51;
    line-height: 20px;
    margin-left: 8px;
    text-align: center;
    flex-shrink: 0;
  }
}
</style>
